// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"1181":"SearchResult","1259":"articalDetail_index","2305":"index_user","3446":"index_layout","4945":"UserEdit","5411":"chat_index","6291":"index_login","7086":"index_home","7832":"index_search"}[chunkId] || chunkId) + ".1762342538206.js";
};